export function convertToPopperPlacement(placement = 'top', secondaryPlacement) {
    if (!secondaryPlacement || secondaryPlacement === 'middle') {
        return placement;
    }
    return `${placement}-${secondaryPlacement}`;
}
export function convertFromPopperPlacement(popperPlacement = 'top') {
    const [placement, secondaryPlacement = 'middle'] = popperPlacement.split('-');
    return {
        placement: placement,
        secondaryPlacement: secondaryPlacement
    };
}
